var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselWedding = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "dadqxaytqa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#dadqxaytqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.18 52.88 3.537 2.217a4.881 4.881 0 0 0 5.16.017l1.817-1.122-4.403-3.288-6.11 2.175z",
    fill: "#0D5369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.094 36.45v7.977c0 1.18.62 2.273 1.633 2.878l12.476 7.459c1.35.808 3.067-.166 3.067-1.74V46.41L9.095 36.45z",
    fill: "#0D5369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B768F",
    d: "m9 36.45 17.249 9.96 17.094-9.728L25.98 26.508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03323A",
    d: "m27.111 25.389 17.737 10.005-4.133-17.397L20.14 6.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5E4B8",
    d: "m11.176 36.335 14.679-8.574 14.995 8.821-14.854 8.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.248 46.41v6.37c0 1.724 1.881 2.79 3.36 1.902l11.752-7.053a4.249 4.249 0 0 0 2.063-3.643v-7.304L26.248 46.41z",
    fill: "#044656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.125 13.295 1.417.827a4.637 4.637 0 0 1 2.038 2.47l.222.634-3.076.462-.601-4.393z",
    fill: "#3B768F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E617B",
    d: "m26.794 26.928 1.43-1.886 14.835 8.533-1.503 2.154-14.795-8.763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.14 6.755 3.953-2.286a3.484 3.484 0 0 1 3.469-.013l16.689 9.482c.872.495.894 1.752.04 2.278l-3.562 2.191L20.14 6.755z",
    fill: "#3B768F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.729 18.406 3.81-2.373a1.451 1.451 0 0 1 2.176.88l3.264 13.03a3.251 3.251 0 0 1-1.675 3.686l-3.455 1.765-4.12-16.988z",
    fill: "#0D5369"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5DBA4",
    d: "m27.978 25.018-5.58-15.912 16.958 9.765 3.684 14.735z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7EDD6",
    d: "m28.178 25.08 5.135-3.57 7.903 4.662 1.967 7.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAC478",
    d: "m27.902 25.023 5.264-3.663-2.07-7.146L22.37 9.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.343 32.107 13.333 7.095c.086.116.17.247.246.392.431.816.401 1.656.342 2.128l1.086-.738c.024-.19.041-.47-.011-.803-.034-.218-.148-.88-.68-1.419a2.253 2.253 0 0 0-.666-.466l-12.486-6.849",
    fill: "#D3BF94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.76 28.395.744-.427a2.765 2.765 0 0 1 1.349-.173c.762.082 1.393.458 1.759.682.568.347.936.69 1.27 1.002a9.693 9.693 0 0 1 1.409 1.652c.333.496.529.893.752 1.344.304.614.514 1.038.693 1.656.202.7.252 1.259.292 1.7.013.148.053.623.02 1.231-.02.388-.054.552-.083.662a2.426 2.426 0 0 1-.42.854l-.5-.16-1.099-.481 1.283-2.438-.731-1.625-2.27-3.176-2.813-1.715",
    fill: "#EE9D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.466 33.498c-.189-.559-.496-1.742-.13-3.12.172-.646.317-1.033.563-1.329.114-.136.428-.505.968-.693.476-.166.876-.105 1.33-.03a5.348 5.348 0 0 1 1.877.694c.714.437 1.12.914 1.777 1.69.331.391.71.843 1.112 1.517a10.067 10.067 0 0 1 1.069 2.557c.305 1.084.317 1.74.318 1.921a4.523 4.523 0 0 1-.145 1.185 4.12 4.12 0 0 1-.159.476c-.179-.064-.438-.16-.747-.286-1.02-.415-1.712-.803-2.435-1.204-2.715-1.507-2.56-1.37-3.163-1.758a50.291 50.291 0 0 1-2.04-1.458l-.167-.126-.028-.036z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.57 34.36a13.46 13.46 0 0 1-.325-1.51c-.1-.642-.149-.97-.076-1.352.028-.147.148-.711.602-1.226.175-.198.408-.456.793-.554.069-.018.212-.048.527-.024a3.793 3.793 0 0 1 1.185.286c.638.275 1.03.649 1.486 1.084a7.81 7.81 0 0 1 1.071 1.265c.37.545.587 1.015.683 1.239.167.384.264.699.356.998.1.322.15.488.19.727.06.352.058.623.056.938-.002.363-.004.544-.053.757a2.18 2.18 0 0 1-.35.77 25.27 25.27 0 0 1-.514-.225c-.383-.173-.913-.425-2.04-1.04-.465-.255-1.157-.633-2.066-1.174a58.586 58.586 0 0 1-1.459-.895",
    fill: "#EE9D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.167 35.464a5.322 5.322 0 0 1-.88-1.845c-.123-.426-.264-.917-.292-1.574a4.73 4.73 0 0 1 .077-1.108c.123-.62.318-.901.42-1.03.06-.074.115-.132.155-.17.038-.009.093-.02.16-.029.162-.022.521-.053 1.077.112.139.042.617.193 1.185.579.465.316.756.63 1.007.906.466.511.745.964.952 1.304.233.383.446.73.638 1.247.147.396.207.69.32 1.244.119.574.177.87.155 1.281a3.477 3.477 0 0 1-.438 1.53",
    fill: "#F5E4B8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.475 25.655.007.733.911.528 1.374-.006.898-.522-.02-.693-.865-.562-1.426-.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FB",
    d: "m27.665 26.388.428.695v-.93l-.449-.458zM25.393 26.916l-.162.907 1.662-.028-.126-.885z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAE6EC",
    d: "m26.767 26.91.126.885 1.2-.712-.428-.695zM24.482 26.388l-.463.738 1.212.697.162-.907z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FB",
    d: "m24.482 26.388-.007-.733-.43.471-.026 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C9CB",
    d: "m24.02 27.126 1.496 1.563.262.142-.547-1.008zM26.893 27.795l-.617 1.122.16-.006 1.657-1.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3DBDD",
    d: "m25.778 28.831-.547-1.008 1.662-.028-.617 1.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.135 36.866-5.91-3.466c.015.067.032.134.05.201.179.644.453 1.212.765 1.707l4.728 2.516a3.282 3.282 0 0 0 .366-.938",
    fill: "#D3BF94"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselWedding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-wedding.df7cd8c958a083536886d3cf38a195a0.svg";